import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule, MatDatepickerModule, MatDialogModule, MatNativeDateModule } from '@angular/material';
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDividerModule } from "@angular/material/divider";
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from "@angular/material/select";
import { IonicModule } from "ionic-angular";
import { AutoCompleteModule } from 'ionic2-auto-complete';
import { InviteUsersDialogComponent } from './invite-users-dialog/invite-users-dialog';
import { MetricCardComponent } from './metric-card/metric-card';
import { UserSelectorComponent } from './user-selector/user-selector';
import { UserUpdateComponent } from './user-update/user-update';
import { WeekSelectorComponent } from './week-selector/week-selector';

@NgModule({
	declarations: [
    MetricCardComponent,
    UserUpdateComponent,
    InviteUsersDialogComponent,
    UserSelectorComponent,
    WeekSelectorComponent
    ],
	imports: [
    AutoCompleteModule,
    IonicModule,
    CommonModule,
    MatInputModule,
    MatCheckboxModule,
    MatCardModule,
    FlexLayoutModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatDividerModule,
    MatButtonModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ],
	exports: [
    MetricCardComponent,
    UserUpdateComponent,
    InviteUsersDialogComponent,
    UserSelectorComponent,
    WeekSelectorComponent
    ],
    entryComponents: [
        InviteUsersDialogComponent
    ]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts